import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Search } from 'lucide-react';
import { LocationSearch } from './LocationSearch';
import { DatePicker } from './DatePicker';
import { GuestPicker } from './GuestPicker';
import { useBooking } from '../hooks/useBooking';
interface SearchBarProps {
  onSearch?: () => void;
}
export function SearchBar({
  onSearch
}: SearchBarProps) {
  const [activeDropdown, setActiveDropdown] = useState<'location' | 'checkIn' | 'checkOut' | 'guests' | null>(null);
  const {
    location,
    checkIn,
    checkOut
  } = useBooking();
  const handleSearch = () => {
    // Basic validation before searching
    if (!location) {
      setActiveDropdown('location');
      return;
    }
    if (!checkIn) {
      setActiveDropdown('checkIn');
      return;
    }
    if (!checkOut) {
      setActiveDropdown('checkOut');
      return;
    }
    if (onSearch) {
      onSearch();
    }
  };
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.6,
    delay: 0.2
  }} className="w-full max-w-4xl mx-auto bg-white/95 backdrop-blur-lg rounded-full shadow-float border border-white/40 px-2 py-2 md:px-3 relative z-20" data-id="element-233">
      <div className="flex flex-col md:flex-row md:items-center h-full" data-id="element-234">
        <LocationSearch isOpen={activeDropdown === 'location'} onOpen={() => setActiveDropdown('location')} onClose={() => setActiveDropdown(prev => prev === 'location' ? null : prev)} data-id="element-235" />

        <div className="hidden md:block w-px h-8 bg-gray-200 shrink-0" data-id="element-236" />

        <DatePicker type="checkIn" isOpen={activeDropdown === 'checkIn'} onOpen={() => setActiveDropdown('checkIn')} onClose={() => setActiveDropdown(prev => prev === 'checkIn' ? null : prev)} data-id="element-237" />

        <div className="hidden md:block w-px h-8 bg-gray-200 shrink-0" data-id="element-238" />

        <DatePicker type="checkOut" isOpen={activeDropdown === 'checkOut'} onOpen={() => setActiveDropdown('checkOut')} onClose={() => setActiveDropdown(prev => prev === 'checkOut' ? null : prev)} data-id="element-239" />

        <div className="hidden md:block w-px h-8 bg-gray-200 shrink-0" data-id="element-240" />

        <GuestPicker isOpen={activeDropdown === 'guests'} onOpen={() => setActiveDropdown('guests')} onClose={() => setActiveDropdown(prev => prev === 'guests' ? null : prev)} data-id="element-241" />

        {/* Search Button */}
        <div className="p-1 md:pl-2 shrink-0 flex items-center" data-id="element-242">
          <button onClick={handleSearch} className="w-full md:w-auto bg-luxury-blue hover:bg-blue-600 text-white rounded-full py-3.5 px-7 flex items-center justify-center space-x-2 transition-all shadow-lg hover:shadow-xl hover:scale-[1.02] active:scale-[0.98]" data-id="element-243">
            <Search className="w-4 h-4" data-id="element-244" />
            <span className="font-semibold text-sm" data-id="element-245">Search</span>
          </button>
        </div>
      </div>
    </motion.div>;
}